"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslationService = exports.bindTransToWindow = void 0;
var wrapT_1 = __importDefault(require("./wrapT"));
exports.bindTransToWindow = function (instance) {
    window.transService = wrapT_1.default(instance);
};
exports.getTranslationService = function (key, option) {
    return window.transService(key, option);
};
